import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { Field, sel } from "@/lib/finance";
import { STATUS, newKey } from "@/components/insaat/common";

export default function ProjectDialog({ project, onClose, onDone }) {
  const [f, setF] = useState({ name: project?.name || "", location: project?.location || "", start_date: project?.start_date || "",
    description: project?.description || "", status: project?.status || "aktif" });
  const [busy, setBusy] = useState(false);
  const [idem] = useState(newKey);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    const body = { ...f, start_date: f.start_date || null };
    try {
      const { data } = project ? await api.put(`/insaat/projects/${project.id}`, body) : await api.post("/insaat/projects", body, { headers: { "Idempotency-Key": idem } });
      toast.success(project ? "İnşaat güncellendi" : "İnşaat eklendi"); onDone(data);
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-lg" data-testid="project-dialog">
        <DialogHeader><DialogTitle>{project ? "İnşaatı Düzenle" : "Yeni İnşaat Ekle"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid grid-cols-2 gap-3">
          <Field label="İnşaat Adı *" className="col-span-2"><Input value={f.name} onChange={set("name")} required minLength={2} maxLength={160} data-testid="project-name-input" /></Field>
          <Field label="Konum" className="col-span-2"><Input value={f.location} onChange={set("location")} maxLength={200} data-testid="project-location-input" /></Field>
          <Field label="Başlangıç Tarihi"><Input type="date" value={f.start_date} onChange={set("start_date")} data-testid="project-start-input" /></Field>
          <Field label="Durum"><select className={`${sel} w-full`} value={f.status} onChange={set("status")} data-testid="project-status-select">
            {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></Field>
          <Field label="Açıklama" className="col-span-2"><Textarea rows={3} value={f.description} onChange={set("description")} maxLength={2000} data-testid="project-description-input" /></Field>
          <DialogFooter className="col-span-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="project-cancel">İptal</Button>
            <Button type="submit" disabled={busy || f.name.trim().length < 2} className="bg-blue-600 hover:bg-blue-700" data-testid="project-save">
              {busy && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
